import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiMoreHorizontal, FiArrowUp, FiArrowDown } = FiIcons;

const StatsCard = ({ title, value, icon, color, subtitle, trend }) => {
  // Parsing trend for visual indicator
  const isPositive = trend && (trend.includes('+') || !trend.includes('-'));
  const trendValue = trend ? trend.match(/[\d.]+%/) : null;
  const percentage = trendValue ? trendValue[0] : '0%';

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      whileHover={{ y: -2 }}
      className="bg-white rounded-3xl p-6 shadow-sm border border-transparent hover:shadow-md transition-all duration-300 relative overflow-hidden"
    >
      <div className="flex justify-between items-start mb-4">
        <div>
          <p className="text-sm font-medium text-gray-500 mb-1">{title}</p>
          <h3 className="text-3xl font-bold text-gray-900">{value}</h3>
        </div>
        <button className="text-gray-300 hover:text-gray-500">
          <SafeIcon icon={FiMoreHorizontal} />
        </button>
      </div>

      <div className="flex items-center justify-between mt-4">
        <div className="flex items-center space-x-2">
          {trend && (
            <div className={`flex items-center px-2 py-1 rounded-full text-xs font-bold ${isPositive ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
              <SafeIcon icon={isPositive ? FiArrowUp : FiArrowDown} className="mr-1 text-[10px]" />
              {percentage}
            </div>
          )}
          <span className="text-xs text-gray-400">{subtitle}</span>
        </div>
        
        {/* Subtle Icon Background */}
        <div className={`p-2 rounded-xl bg-${color}-50 bg-opacity-50`}>
          <SafeIcon icon={icon} className={`text-${color}-500 text-xl`} />
        </div>
      </div>
    </motion.div>
  );
};

export default StatsCard;